import Vue from 'vue'
import Vuex from 'vuex'

import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

Vue.use(Vuex)

import auth from './auth/auth.js'
import reports from './reports'
import quotations from './quotations/quotations.js'
import activities from './activities/activities.js'
import contacts from './contacts/contacts.js'
import users from './users/users.js'
import enquiries from './enquiries/enquiries.js'
import customers from './customers/customers.js'
import myActivities from './myActivities'
import tasks from './tasks'
import actualSales from './actualSales'
import salesForecast from './salesForecast'
import commons from './commons'
import newContacts from './newContacts/newContacts.js'
import dashboard from './dashboard'

export default new Vuex.Store({
  strict: false,
  state,
  actions,
  mutations,
  getters,
  modules: {
    auth,
    reports,
    quotations,
    activities,
    contacts,
    enquiries,
    customers,
    myactivities: myActivities,
    tasks,
    actualSales,
    salesForecast,
    commons,
    newContacts,
    users,
    dashboard
  }
})